import SvgIcon from './SvgIcon';

export default function AvatarIcon(props) {
  return (
    <SvgIcon width="20px" height="19px" {...props} viewBox="0 0 20 19">
      <g
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        transform="translate(-1111.000000, -147.000000)"
        strokeLinecap="square">
        <g
          transform="translate(1113.000000, 148.000000)"
          stroke="currentColor"
          strokeWidth="2">
          <path d="M0.221825407,0.721825407 L15.7781746,16.2781746" />
          <path
            d="M0.221825407,0.721825407 L15.7781746,16.2781746"
            transform="translate(8.000000, 8.500000) scale(-1, 1) translate(-8.000000, -8.500000) "
          />
        </g>
      </g>
    </SvgIcon>
  );
}
